// extracted by mini-css-extract-plugin
module.exports = {"skillcard":"skillcard-module--skillcard--1abZJ","skillcard__img":"skillcard-module--skillcard__img--rfJLt","skillcard__header":"skillcard-module--skillcard__header--3R5jv"};